'use strict';

import template from './braintree_modal.html';

export default {
  bindings: {
    paymentData: '<',
    done: '&',
    paymentProvider: '<',
    reloadParams: '<',
  },
  template: template,
  controller: function ($timeout, $location, config, paymentsSubscription, userModel, reloadPage) {
    'ngInject';
    var s = this;
    userModel.getBraintreeToken().then((result) => {
      braintree.dropin.create({
        authorization: result.clientToken,
        container: '#dropin-container',
        threeDSecure: {
          amount: s.paymentData.price
        },
        card: {
          cardholderName: {
            required: true
          }
        }
      }).then(function (instance) {
        s.pay = () => {
          instance.requestPaymentMethod().then(function (payload) {
            // Check liabilityShift for 3dsecure
            if (payload.liabilityShiftPossible === true && payload.liabilityShifted === false) {
                s.errorShake = true;
                s.isSaving = false;
                instance.clearSelectedPaymentMethod();
                return;
            }

            let data = {
              nonce: payload.nonce,
              duration: s.paymentData.duration,
              price: s.paymentData.price
            };

            userModel.processBraintreePayment(data).then(function (response) {
              if (response.success) {
                s.paymentData.currency = userModel.item.membership.pricePoints.currencyDefault;
                let urlToReload = s.paymentProvider.getBraintreeReloadUrl('AUTHORISED', s.paymentData);
                reloadPage.doIt(urlToReload);
                s.done();
              }
              else {
                console.log(response);
                s.errorShake = true;
                s.isSaving = false;
                instance.clearSelectedPaymentMethod();
              }
            });

            s.isSaving = true;

          }).catch(function (err) {
            console.error(err);
          });
        };
      }).catch(function (err) {
        console.error(err);
      });
    });

    this.userModel = userModel;
  }
};



// WEBPACK FOOTER //
// ./app/src/components/braintree_modal/braintree_modal.js